module.exports = __webpack_public_path__ + "static/media/29ADMSPC32.79ece8f7.jpg";